import { z } from 'zod';

export const InputSchema = z.object({
    customerId: z.number(),
    body: z.object({
        amount: z.string(),
        currencyCode: z.string(),
        error: z.object({
            code: z.string(),
            correlationId: z.string(),
            detailedMessage: z.string(),
            displayMessage: z.string(),
            message: z.string(),
        }),
        merchantRefNum: z.string(),
    }),
});

export type FailedPaymentsPaysafeInputType = z.infer<typeof InputSchema>;

export const SuccessResponseSchema = z.object({
    data: z.object({}),
});

type TsuccessResponseType = z.infer<typeof SuccessResponseSchema>;

export const ErrorResponseSchema = z.object({
    error: z.object({
        code: z.string().optional().nullable(),
        message: z.string().optional().nullable(),
    }),
});

export const TrpcErrorResponseSchema = z.object({
    errors: z.array(
        z.object({
            code: z.string().optional().nullable(),
            message: z.string().optional().nullable(),
        })
    ),
});

type TerrorResponseType = z.infer<typeof TrpcErrorResponseSchema>;

export type TresponseTypeType =
    | { responseStatus: 'success'; response: TsuccessResponseType }
    | { responseStatus: 'error'; data: TerrorResponseType };
